import React, { useEffect, useState } from 'react'
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd'
import { useTranslation } from 'react-i18next'

import style from '../Dialog.module.scss'

import Dialog from '../index'
import Button from '../../Button/Button'
import Input from '../../Input/Input'
import Label from '../../InputLabel'
import StyledCheckbox from '../../Checkbox/Checkbox2'
import RadioButton from '../../Radio'
import DragDotsIcon from '../../../Icons/DragDotsIcon'

const TrashIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={15}
      height={17}
      fill="none"
      {...props}
    >
      <path
        fill="#FD0D1B"
        d="m12.45 14.768.508-10.719h.867a.59.59 0 0 0 0-1.18h-3.351v-1.07A1.73 1.73 0 0 0 8.56.01H5.836a1.73 1.73 0 0 0-1.914 1.789v1.07H.586a.592.592 0 0 0-.413 1.007.59.59 0 0 0 .413.173h.867l.513 10.727a1.723 1.723 0 0 0 1.852 1.758h6.781a1.74 1.74 0 0 0 1.851-1.766Zm-7.273-12.9a.7.7 0 0 1 .75-.711h2.555a.7.7 0 0 1 .75.711v1H5.177v-1ZM3.942 15.354a.75.75 0 0 1-.758-.75L2.676 4.049h9.031l-.483 10.555a.733.733 0 0 1-.758.75H3.942Zm5.453-1.266a.48.48 0 0 0 .453-.5l.219-7.7a.467.467 0 0 0-.445-.508.491.491 0 0 0-.453.5l-.219 7.7a.462.462 0 0 0 .445.508Zm-4.375 0a.468.468 0 0 0 .445-.508l-.219-7.7a.5.5 0 0 0-.453-.5.458.458 0 0 0-.445.508l.219 7.7a.47.47 0 0 0 .453.5Zm2.188 0a.49.49 0 0 0 .461-.508V5.893a.489.489 0 0 0-.461-.508.489.489 0 0 0-.461.508v7.688a.489.489 0 0 0 .461.507Z"
      />
    </svg>
  )
}

const initialFormValues = {
  name: '',
  field_type: 'entry_field',
  dropdown_fields: [],
  start_work: true,
  finish_work: false,
};

const CreateCustomCategory = ({handleClose, title, open, buttonTitle, createCategory, initialValues, isEdit}) => {
  const { t } = useTranslation()

  const [formValues, setFormValues] = useState(initialFormValues)

  useEffect(() => {
    if (initialValues) {
      setFormValues({
        ...initialFormValues,
        ...initialValues,
        field_type: initialValues.field_type || 'entry_field',
        dropdown_fields: initialValues.dropdown_fields || [],
      })
    } else {
      setFormValues(initialFormValues)
    }
  }, [initialValues, open])

  const handleCategoryChange = (event) => {
    const { name, value } = event.target;
    setFormValues((prevState) => ({
      ...prevState,
      [name]: value
    }))
  }

  const handleAddDropdownField = () => {
    setFormValues((prev) => ({
      ...prev,
      dropdown_fields: [...prev.dropdown_fields, {name: ''}],
    }));
  };

  const handleDropdownFieldChange = (idx, value) => {
    setFormValues((prev) => {
      const updated = [...prev.dropdown_fields]
      updated[idx].name = value
      return {
        ...prev,
        dropdown_fields: updated
      }
    })
  }

  const handleRemoveDropdownField = (idx) => {
    setFormValues((prev) => {
      const updated = [...prev.dropdown_fields];
      updated.splice(idx, 1);
      return { ...prev, dropdown_fields: updated };
    });
  };

  const handleDragEnd = (result) => {
    if (!result.destination) return;
    const items = Array.from(formValues.dropdown_fields)
    const [removed] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, removed);
    setFormValues((prev) => ({ ...prev, dropdown_fields: items }));
  };

  const handleExited = () => {
    setFormValues(initialFormValues);

  };
  const onClose = () => {
    setFormValues(initialFormValues);
    handleClose();

  };

  const handleSubmit = () => {
    const post = {
      ...formValues,
      dropdown_fields: formValues.dropdown_fields
    }
    createCategory(post)
  }
  

  return (
    <Dialog handleClose={onClose} onExited={handleExited} open={open} title={title}>
      <div className={style.customCategory}>
        <div className={style.formControl}>
          <Label text={t('Category name')} htmlFor='category' />
          <Input
            placeholder={`${t('Enter category name')}`}
            value={formValues.name}
            name='name'
            fullWidth
            onChange={handleCategoryChange}
          />
        </div>

        <div className={style.formControl}>
          <RadioButton
            options={[
              { id: 'entry_field', name: 'field_type', label: t('Entry field') },
              { id: 'dropdown_fields', name: 'field_type', label: t('Dropdown + fields') }
            ]}
            disabled={isEdit}
            checked={formValues.field_type}
            onChange={handleCategoryChange}
          />
        </div>

        {formValues.field_type === 'dropdown_fields' && (
          <div className={style.formControl}>
            <div size="small" onClick={handleAddDropdownField} className={style.addDropdownFieldButton}>
              + {t('add new dropdown field')}
            </div>
            <DragDropContext onDragEnd={handleDragEnd}>
              <Droppable droppableId="dropdownFieldsList">
                {(provided) => (
                  <div ref={provided.innerRef} {...provided.droppableProps}>
                    {(formValues.dropdown_fields || []).map((field, idx) => (
                      <Draggable key={idx} draggableId={String(idx)} index={idx}>
                        {(provided, snapshot) => (
                          <div
                            ref={provided.innerRef}
                            {...provided.draggableProps}
                            {...provided.dragHandleProps}
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                              gap: 8,
                              marginBottom: 8,
                              ...provided.draggableProps.style,
                            }}
                            className={style.dropdownFieldItem}
                          >
                            <DragDotsIcon />
                            <input
                              value={field.name}
                              onChange={e => handleDropdownFieldChange(idx, e.target.value)}
                              placeholder={t('Dropdown field name')}
                              className={style.dropdownFieldInput} />
                            <div onClick={() => handleRemoveDropdownField(idx)} style={{cursor: 'pointer'}}>
                              <TrashIcon
                                style={{color: '#d32f2f', width: 20, height: 20}}
                                title={t('Remove field')} />
                            </div>
                          </div>
                        )}
                      </Draggable>
                    ))}
                    {provided.placeholder}
                  </div>
                )}
              </Droppable>
            </DragDropContext>
          </div>
        )}
        <div className={style.checkboxContainer}>
          <StyledCheckbox
            label={t('Start work additional category')}
            checked={formValues.start_work}
            onChange={(e) => setFormValues({ ...formValues, start_work: !formValues.start_work, finish_work: !formValues.start_work ? false : formValues.finish_work })}
          />
          <StyledCheckbox
            label={t('Finish work additional category')}
            checked={formValues.finish_work}
            onChange={(e) => setFormValues({ ...formValues, finish_work: !formValues.finish_work, start_work: !formValues.finish_work ? false : formValues.start_work })}
          />
        </div>
        <div className={style.buttonSaveBlock}>
          <Button disabled={formValues.name === ''} onClick={handleSubmit} fillWidth size='big'>
            {buttonTitle}
          </Button>
        </div>
      </div>
    </Dialog>
  );
}

export default CreateCustomCategory
